import clsx from 'clsx'
import { IMaskInput } from 'react-imask'

type CurrencyInputProps = {
  label: string
  id: string
  amount: number
  setAmount: (val: number) => void
  decimal?: number
  disabled?: boolean
  min: number
  max?: number
  autoFocus?: boolean
}

export const CurrencyInput = ({
  label,
  amount,
  setAmount,
  disabled,
  decimal = 2,
  id,
  min,
  max,
  autoFocus,
  ...props
}: CurrencyInputProps) => {
  const inputClass = clsx(
    'w-full text-gravel dark:text-white text-xl pb-1 pt-2 bg-transparent border-b-2 border-rock invalid:border-red focus:outline-none focus:text-clementine dark:focus:text-sun invalid:border-color-red-500 rounded-none',
    { 'border-b-red-500': amount <= 0 }
  )
  return (
    <div className="flex flex-col gap-3" data-testid="input-input-container">
      <label htmlFor={id} className="uppercase" data-testid="input-input-label">
        {label}
      </label>
      <IMaskInput
        className={inputClass}
        disabled={disabled}
        normalizeZeros
        id={id}
        mask={Number}
        placeholder="00.00"
        value={amount.toString()}
        min={min}
        max={max}
        thousandsSeparator=","
        radix="."
        scale={decimal}
        autoFocus={autoFocus}
        onAccept={(value, mask, e) => {
          if (e) {
            if (value === '') {
              setAmount(0)
            } else {
              setAmount(Number.parseFloat(mask.unmaskedValue))
            }
          }
        }}
        {...props}
        data-testid={`currency-input-${id}`}
      />
    </div>
  )
}

/*
 * Code Improvement Suggestions:
 *
 * 1. Consider adding form validation and error messages for invalid inputs
 * 2. The component could benefit from a currency symbol display
 * 3. Add event handlers for keyboard navigation (like tab and arrow keys)
 * 4. Consider adding accessibility features for screen readers
 * 5. Add a clear button for easily resetting the input
 * 6. Consider adding input masking options as props for more flexibility
 * 7. The error state styling could be enhanced with proper error messages
 */
